import type { CoinCategory, CoinCity } from '@/lib/types';

export interface CoinCategoryMeta {
  label: string;
  icon: string;
  badgeClass: string;
  dotClass: string;
}

export const coinCategoryMeta: Record<CoinCategory, CoinCategoryMeta> = {
  VU: {
    label: 'Vu à…',
    icon: 'ri-eye-line',
    badgeClass: 'bg-accent-100 text-accent-800',
    dotClass: 'bg-accent-500',
  },
  CONFESSION: {
    label: 'Confession',
    icon: 'ri-chat-smile-2-line',
    badgeClass: 'bg-primary-100 text-primary-700',
    dotClass: 'bg-primary-500',
  },
  COUP_DE_COEUR: {
    label: 'Coup de cœur',
    icon: 'ri-heart-3-line',
    badgeClass: 'bg-secondary-100 text-secondary-900',
    dotClass: 'bg-secondary-500',
  },
  QUESTION: {
    label: 'Question',
    icon: 'ri-question-line',
    badgeClass: 'bg-foreground-100 text-foreground-700',
    dotClass: 'bg-foreground-500',
  },
};

export const coinCategories = Object.keys(coinCategoryMeta) as CoinCategory[];

export const coinCities: { value: CoinCity; label: string }[] = [
  { value: 'DOLE', label: 'Dole' },
  { value: 'LONS', label: 'Lons' },
  { value: 'JURA', label: 'Jura' },
];

const cityLabels: Record<CoinCity, string> = {
  DOLE: 'Dole',
  LONS: 'Lons-le-Saunier',
  JURA: 'Jura',
};

export function cityLabel(city: CoinCity): string {
  return cityLabels[city];
}

const aliases: Record<CoinCity, string[]> = {
  DOLE: ['Un Dolois', 'Une Doloise', 'Un passant de Dole', 'Un voisin de Dole'],
  LONS: ['Un Lédonien', 'Une Lédonienne', 'Un passant de Lons'],
  JURA: ['Un Jurassien', 'Une Jurassienne', 'Une âme du Jura'],
};

export function randomAlias(city: CoinCity): string {
  const list = aliases[city];
  return list[Math.floor(Math.random() * list.length)];
}